import gql from 'graphql-tag'

export const fetchDomainsSelect = () => {
	return {
		query: gql`
			{
				domains: domain(order_by: { name: asc }) {
					id
					name
				}
			}
		`
	}
}
